import React from 'react';
import Button from '../../../components/ui/Button'; // Assuming path is correct
import Icon from '../../../components/AppIcon';   // Assuming path is correct

/*
  CSS for the VERTICAL Infinite Scroller
  -----------------------------------------
  IMPORTANT: This CSS should be in your project's global stylesheet
  (e.g., globals.css or index.css).
*/
const ScrollerStylesVertical = () => (
  <style jsx global>{`
    .scroller-vertical {
      position: relative;
      overflow: hidden;
      /* Define a fixed height for the scrolling container */
      height: 700px; 
      width: 100%;
    }

    .scroller-inner-vertical {
      display: flex;
      flex-direction: column;
      gap: 1rem; /* Space between images */
      height: max-content;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
      animation-duration: 55s; /* Adjust duration to control speed */
    }

    /* Vertical Animation Keyframes */
    @keyframes scroll-up {
      0% { transform: translateY(0%); }
      100% { transform: translateY(-50%); }
    }

    @keyframes scroll-down {
      0% { transform: translateY(-50%); }
      100% { transform: translateY(0%); }
    }
    
    .animate-scroll-up {
        animation-name: scroll-up;
    }

    .animate-scroll-down {
        animation-name: scroll-down;
    }

    /* Vertical Fade Effect Overlay */
    .scroller-vertical::before,
    .scroller-vertical::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      height: 20%; /* Height of the fade */
      z-index: 2;
      pointer-events: none;
    }

    .scroller-vertical::before {
      top: 0;
      background: linear-gradient(to bottom, white, transparent);
    }

    .scroller-vertical::after {
      bottom: 0;
      background: linear-gradient(to top, white, transparent);
    }
  `}</style>
);


// --- Vertical Infinite Image Scroller Component (Unchanged) ---
const InfiniteScrollerVertical = ({ images, direction }) => {
  const extendedImages = [...images, ...images];

  return (
    <div className="scroller-vertical">
      <div 
        className={`scroller-inner-vertical ${direction === 'up' ? 'animate-scroll-up' : 'animate-scroll-down'}`}
      >
        {extendedImages.map((src, index) => (
          <div key={index} className="w-full h-64 flex-shrink-0">
            <img 
              src={src} 
              alt={`Scrolling gallery image ${index + 1}`} 
              className="w-full h-full object-cover rounded-lg shadow-md"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
};


// --- UPDATED HeroSection Component with Trust Indicators ---
const HeroSection = () => {
  const handleContactClick = () => {
    window.location.href = 'tel:0727937010';
  };

  const handleInquiryClick = () => {
    window.location.href = '/contact';
  };

  // --- IMPORTANT: Replace with your actual image paths ---
  const columnOneImages = [
    '/gallery/review1.jpg',
    '/gallery/review2.jpg',
    '/gallery/review3.jpg',
    '/gallery/review4.jpg',
    '/gallery/review5.jpg',

  ];

  const columnTwoImages = [
    '/gallery/review6.jpg',
    '/gallery/review7.jpg',
    '/gallery/review8.jpg',
    '/gallery/review9.jpg',
    '/gallery/review10.jpg'
  ];

  return (
    <>
      <ScrollerStylesVertical />
      <section className="min-h-screen bg-white text-gray-800 flex items-center">
        <div className="container mx-auto px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
            
            {/* --- Left Column: Text Content --- */}
            <div className="text-center lg:text-left py-12">
              <div className="mb-8">
                <h1 className="font-heading font-bold text-4xl md:text-5xl lg:text-6xl text-gray-900 mb-4 leading-tight">
                  Creating Unforgettable
                  <span className="block text-accent">Wedding Moments</span>
                </h1>
                <p className="font-body text-lg md:text-xl text-gray-600 max-w-xl mx-auto lg:mx-0 leading-relaxed">
                  The Award Winning Events and Decor company of the year 2019. We specialize in turning your aspirations into reality with elegant decor and flawless execution.
                </p>
              </div>

              <div className="mb-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start space-y-4 sm:space-y-0 sm:space-x-8">
                <a href="tel:0727937010" className="flex items-center space-x-2 text-gray-700 hover:text-accent transition-colors">
                  <Icon name="Phone" size={20} className="text-accent" />
                  <span className="font-mono text-lg">0727 937 010</span>
                </a>
                <div className="hidden sm:block w-px h-6 bg-gray-300"></div>
                <a href="tel:0721320787" className="flex items-center space-x-2 text-gray-700 hover:text-accent transition-colors">
                  <Icon name="Phone" size={20} className="text-accent" />
                  <span className="font-mono text-lg">0721 320 787</span>
                </a>
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start space-y-4 sm:space-y-0 sm:space-x-6">
                <Button variant="default" size="lg" onClick={handleContactClick} className="bg-accent text-white hover:bg-accent/90 shadow-lg px-8 py-3 w-full sm:w-auto">
                  <div className="flex items-center justify-center space-x-2">
                    <Icon name="Phone" size={20} />
                    <span>Call Now</span>
                  </div>
                </Button>
                <Button variant="outline" size="lg" onClick={handleInquiryClick} className="border-gray-400 text-gray-700 hover:bg-gray-100 px-8 py-3 w-full sm:w-auto">
                  <div className="flex items-center justify-center space-x-2">
                    <Icon name="MessageSquare" size={20} />
                    <span>Get Quote</span>
                  </div>
                </Button>
              </div>

              {/* --- NEW: Trust Indicators Section --- */}
              <div className="mt-12 pt-8 border-t border-gray-200">
                <div className="flex flex-col md:flex-row items-center justify-center lg:justify-start gap-y-6 gap-x-12">
                  <div className="flex items-center space-x-3">
                    <Icon name="Award" size={24} className="text-accent" />
                    <span className="font-body text-gray-600">Premium Service</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <Icon name="Users" size={24} className="text-accent" />
                    <span className="font-body text-gray-600">500+ Happy Couples</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <Icon name="Star" size={24} className="text-accent" />
                    <span className="font-body text-gray-600">5-Star Reviews</span>
                  </div>
                </div>
              </div>
              
            </div>

            {/* --- Right Column: Vertical Infinite Scroller Gallery (Unchanged) --- */}
            {/* This container remains hidden on mobile (below lg) and appears on desktop */}
            <div className="hidden lg:flex gap-4">
                <div className="w-1/2">
                    <InfiniteScrollerVertical images={columnOneImages} direction="down" />
                </div>
                <div className="w-1/2">
                    <InfiniteScrollerVertical images={columnTwoImages} direction="up" />
                </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;